import { BaseObject } from "../core/BaseObject";

export class MovementType extends BaseObject {
    movementTypeId: number;
    name: string;
}